import Input from '../../../components/Input'
import Card from '../../../components/Card'
import React from 'react'
import { Login } from '../../../types/Subscription'
import { useTranslation } from 'react-i18next'

const LoginForm: React.FC<{
    data: Partial<Login>
    changeData: (data: Partial<Login>) => void
}> = ({ data, changeData }) => {
    const { t } = useTranslation(['settings'])
    return (
        <Card title={t('subscription.loginInfos')} classes={'zr-my-3'}>
            <div className={'zr-row'}>
                <div className={'zr-col-12 zr-col-md-6 zr-my-3'}>
                    <Input
                        type={'email'}
                        placeholder={'E-Mail'}
                        property={'email'}
                        value={data.email ?? ''}
                        onChange={(_, value) => changeData({ email: value })}
                    />
                </div>
                <div className={'zr-col-12 zr-col-md-6 zr-my-3'}>
                    <Input
                        type={'password'}
                        placeholder={t('subscription.password')}
                        property={'password'}
                        value={data.password ?? ''}
                        onChange={(_, value) => changeData({ password: value })}
                    />
                </div>
            </div>
        </Card>
    )
}

export default LoginForm
